module.exports = __webpack_public_path__ + "img/esicIcon.791d5147.svg";